import { stemCategories } from '../constants/stemCategories'

export const getCategoryFromInstrument = (instrument: string) => {
  for (const category of Object.keys(stemCategories)) {
    const instruments = stemCategories[category]

    if (instruments.includes(instrument)) {
      return category
    }
  }

  return 'Unknown'
}
